import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=aeb29030&scoped=true&"
import script from "./Clause.vue?vue&type=script&lang=js&"
export * from "./Clause.vue?vue&type=script&lang=js&"
import style0 from "./Clause.vue?vue&type=style&index=0&id=aeb29030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb29030",
  null
  
)

export default component.exports